import testcover from '../assets/projectcover.jpg';
import Geo01cover from '../assets/Project01_Gen_02.jpg';
import Geo02cover from '../assets/Project05_MUC.jpg';
import AI01cover from '../assets/Project02_CG_02.jpg';
import AI02cover from '../assets/PelicanFlowData.png';
import CD01cover from '../assets/Pelicanflow-data.png';
import Urban01cover from '../assets/Project021_Pattern.jpg';
import Urban02cover from '../assets/Project03_ZH.jpg';
import Design01cover from '../assets/Project04_Synergy.jpg';
import Design02cover from '../assets/Project052_Airport.jpg';
import Design03cover from '../assets/Project06_ZG.jpg';

export const projectCategories = [
    {
      code: '01',
      title: 'Machine learning, and Computational Design',
      introduction: "This category includes my recent exploration over Machine Learning/Deep Learning and Computational Design Tool Development.",
      projects: [
        {
          title: 'Generative Cities',
          image: AI01cover,
          description: 'an experiment of generative urban fabric by utilising unsurpervised machine learning, aiming at balances diverse result and controllable parameters, accelerating the design process.',
          link: '/projects/AI/ai1',
          skills: ["Unsupervised Machine Learning","Feature Engineering", "Grasshopper","Urban Fabric Generation","Python"]
        },
        {
          title: 'PelicanFlow×Plot Data Workflow',
          image: CD01cover,
          description: 'The second stage of Pelicanflow focuses on applying the tool in urban planning practice, building a bridge between data and design scenarios.',
          link: '/projects/AI/cd1',
          skills: ["Python", "Grasshopper", "Workflow","Data-Driven Design","Master Planning"]
        },
        {
          title: 'PelicanFlow×Data',
          image: AI02cover,
          description: 'Grasshopper plugin developed with PythonScript, designed to simplify burdensome and repetitive data handling and visualisation tasks, enabling professionals to focus on design rather than data organization.',
          link: 'https://pelicanflow.vercel.app/projects/Documentation',
          skills: ["Python", "Grasshopper SDK","Excel","Data Structure"]
        },
      ],
    },
    {
      code: '02',
      title: 'Big Data and Geospatial Analysis',
      introduction: "This category contains projects related to Geospatial Analysis, utilizing big data to provide valuable planning insights and support well-informed policy decisions.",
      projects: [
        {
          title: 'Transit-Induced-Gentrification:Evidence from East London',
          image:  Geo01cover,
          description: 'This is a geo-spatial analysis project to identify the effect on East London neighbourhoods by the extensions of London Overground and Dockland Light Railway',
          link: '/projects/Geospatial/geo1',
          skills: ["Econometrics", "Difference in Differences", "TOD","Gentrification","GIS","Python"]
        },
        {
          title: 'Inside Out: Recalibrating MMR',
          image:  Geo02cover,
          description: 'This project develops a tool to evaluate the impacts of the ‘Zweite Stammstrecke’ Express Rail Project on the Munich Metropolitan Region. The findings offer valuable insights for better achieving Transit-oriented development',
          link: '/projects/Geospatial/geo2',
          skills: ["K-Mean Cluster Analysis", "TOD", "Data Processing and Visualisation","Python"]
        },

      ],
    },
    {
      code: '03',
      title: 'Strategic Planning',
      introduction: "This category includes strategic/spatial planning project on a regional scale",
      projects: [
        {
          title: 'Live with Water: A pattern language towards water-oriented urban development',
          image:  Urban01cover,
          description: 'This is my master thesis at TU delft,developing a toolkit for urban planners and designers to build a water-oriented city',
          link: '/projects/Planning/urban1',
          skills: ["Urban metabolism","Resilient Strategy", "Circular Economy","Sponge city","GIS"]
        },
        {
          title: 'Liv/fe Transition:To a Healthy Agriculture Sector with Livestock as an Integral Part of Life',
          image:  Urban02cover,
          description: 'An integrated framework for energy-transition and a circular agrifood sectors, by encouraging local production and promoting diet transition among consumers',
          link: '/projects/Planning/urban2',
          skills: ["Vision Masterplanning", "Agri-food sector", "Circular Economy","GIS"]
        },
      ],
    },
    {
      code: '04',
      title: 'Urban Design and Architecture',
      introduction: "This category includes urban design and architecture design projects on a district/neighbourhood/block scale.",
      projects: [
        {
          title: 'Seeing Energy? Regeneration of TU Delft Power Station',
          image:  Design01cover,
          description: 'Energy-led urban design/regeneration strategy for TU Delft Campus by rethinking the “energy flow” in built environment.',
          link: '/projects/Design/design1',
          skills: ["Environmental Analysis", "Space Syntax", "Energy System","Net-zero District"]
        },
        {
          title: 'Hallbergmoos 2050:Green Airport City of Munich',
          image:  Design02cover,
          description: 'This project explores the potential of Hallbergmoos as an airport city, envisioning its critical role as a new engine and a new gate for Munich in the decades to come.',
          link: '/projects/Design/design2',
          skills: ["Aerotropolis", "Gateway", "Transit-oriented Development"]
        },
        {
          title: 'Boundless Zhang Garden',
          image:  Design03cover,
          description: 'A urban regeneration and design project in Shanghai, Bachelor’s Graduation Project at Tongji University, which won the Gold Award of academic year 2020 in China Living Environment Design Competition',
          link: '/projects/Design/design3',
          skills: ["Participative Regeneration", "Culture District", "Mixed-Use District"]
        },
      ],
    },
  ];